import Vue from "vue";
import Vuex from "vuex";
import Token from 'utils/token';
// import createPersistedState from "vuex-persistedstate";
import { getPublicKey, getAmountInfo ,getMemberInfo } from "api/user.js";
import {
  domainQuery,
  domainTypeList,
  getDomainSuffix,
  getRegionList,
  sensitiveWords
} from "api/domain.js";

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    publicKey: "",
    prevRouter: {
      name: "index",
      path: "/",
      query: {},
      params: {},
    },
    token: "",
    expiration: 0,
    expiresIn: 0,
    refreshToken: "",
    tokenType: "",
    user: "",
    freezeAmount: 0, // 冻结金额
    balance: 0, // 可用余额
    domainQueryData: {
      domainSufNameList: [], // 域名构造
      domainTypeList: [], // 域名品类
      domainConstructionList: [], // 域名构造
      domainTraitList: [], // 域名特征
      domainLenList: [], // 域名长度
      registeredAtList: [], // 注册日期
      domainSuffix: [], // 域名后缀
      sensitiveWords:[], // 敏感词
    },
    // 复制模板数据
    templateCopy: {},
    areas: [], // 省市区
    countries: [], // 国家
    routeParamsList: [], // 跳转路由参数
  },
  mutations: {
    MUT_PUBLIC_KEY(state, data) {
      state.publicKey = data;
    },
    MUT_TOKEN_INFO(state, data) {
      if (data != null) {
        state.token = data.accessToken || "";
        state.expiration = data.expiration || "";
        state.expiresIn = data.expiresIn || "";
        state.refreshToken = data.refreshToken || "";
        state.tokenType = data.tokenType || "";
        Token.set(data)
      } else {
        Token.remove();
      }
    },
    MUT_LOGOUT(state) {
      state.token = "";
      state.expiration = "";
      state.expiresIn = "";
      state.refreshToken = "";
      Token.remove();
    },
    MUT_ROUTE(state, data) {
      state.prevRouter.name = data.name;
      state.prevRouter.params = data.params;
      state.prevRouter.path = data.path;
      state.prevRouter.query = data.query;
    },
    MUT_AMOUNT(state, data) {
      state.balance = data.balance;
      state.freezeAmount = data.freezeAmount;
    },
    MUT_BALANCE(state, data) {
      state.balance = data;
    },
    MUT_USER_INFO(state, data) {
      state.user = data;
    },
    MUT_USER_INFO_USERNAME(state, data) {
      state.user.username = data;
    },
    MUT_USER_INFO_PHONENUMBER(state, data) {
      state.user.phoneNumber = data;
    },
    MUT_USER_INFO_EMAIL(state, data) {
      state.user.email = data;
    },
    MUT_USER_INFO_COMPANY(state, data) {
      state.user.company = data;
    },
    MUT_USER_PART_INFO(state, data) {
      state.user.nickname = data.nickname;
      state.user.sex = data.sex;
      state.user.birthday = data.birthday;
      state.user.qq = data.qq;
      state.user.wechat = data.wechat;
      state.user.province = data.province;
      state.user.city = data.city;
      state.user.area = data.area;
      state.user.address = data.address;
      state.user.postcode = data.postcode;
      state.user.fax = data.fax;
      state.user.wechatImg = data.wechatImg;
    },
    MUT_DOMAIN_QUERY(state, data) {
      state.domainQueryData.domainSufNameList = data.domainSufNameList;
      state.domainQueryData.domainConstructionList =
        data.domainConstructionList;
      state.domainQueryData.domainTraitList = data.domainTraitList;
      state.domainQueryData.domainLenList = data.domainLenList;
      state.domainQueryData.registeredAtList = data.registeredAtList;
    },
    MUT_DOMAIN_TYPELIST(state, data) {
      state.domainQueryData.domainTypeList = data;
    },
    MUT_DOMAIN_SUFFIX(state, data) {
      state.domainQueryData.domainSuffix = data;
    },
    MUT_SENSITIVE_WORDS(state, data) {
      state.domainQueryData.sensitiveWords = data;
    },
    // 复制模板数据
    MUT_DOMAIN_TEMPLATECOPY(state, data) {
      state.templateCopy = data;
    },
    MTU_REGION_LIST(state, data) {
      state.countries = data.countries;
      state.areas = data.areas;
    },
    // 路由跳转需要的参数
    MTU_ROUTE_PARAMS_LIST(state, data) {
      state.routeParamsList = data;
    },
  },
  actions: {
    ACT_PUBLIC_KEY({ commit }) {
      getPublicKey().then((res) => {
        if (res.code === 200 && res.result) {
          commit("MUT_PUBLIC_KEY", res.data);
        }
      });
    },
    ACT_USER_INFO({ commit }){
      getMemberInfo().then((res) => {
        if (res.code === 200 && res.result) {
          commit("MUT_USER_INFO", res.data);
        }
      });
    },
    ACT_DOMAIN_QUERY({ commit }) {
      domainQuery().then((res) => {
        if (res.code === 200 && res.result) {
          commit("MUT_DOMAIN_QUERY", res.data);
        }
      });
      domainTypeList().then((res) => {
        if (res.code === 200 && res.result) {
          const temp = res.data.map((o) => {
            let children = o.typeChildrenList.map((o2) => {
              return { label: o2.label, value: o2.value };
            });
            return { label: o.type, value: o.typeValue, children };
          });
          commit("MUT_DOMAIN_TYPELIST", temp);
        }
      });
      getDomainSuffix().then((res) => {
        if (res.code === 200 && res.result) {
          commit("MUT_DOMAIN_SUFFIX", res.data);
        }
      });
      sensitiveWords().then((res) => {
        if (res.code === 200 && res.result) {
          commit("MUT_SENSITIVE_WORDS", res.data);
        }
      });
    },
    ACT_REGION_LIST({ commit }) {
      getRegionList().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          commit("MTU_REGION_LIST", data);
        }
      });
    },
    // 获取账户金额
    ACT_AMOUNT_INFO({ commit }) {
      getAmountInfo().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          commit("MUT_AMOUNT", data);
        }
      });
    },
  },
  modules: {},
});
